module.exports = __webpack_public_path__ + "media/track_guides/play_icon-7dc0cb36.svg";